import { Component} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-view-assets-button',
  template: `<span><button style="height: 20px" (click)="invokeParentMethod()" class="btn btn-info" title="View Assets"><i class="fas fa-project-diagram fa-flip-vertical"></i></button></span>`,
  styles: [
    `.btn {
             line-height: 0.5;
             background: purple !important;
         }`
  ]
})
export class ViewAssetsButtonComponent implements ICellRendererAngularComp  {

  public params: any;

  agInit(params: any): void {
      this.params = params;
  }

  public invokeParentMethod() {
      this.params.context.componentParent.onAssetButtonClick(this.params);
  }

  refresh(): boolean {
      return false;
  }

}